/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTImageInput } from './image-input';
export type {
	KTImageInputConfigInterface,
	KTImageInputInterface,
} from './types';
